/**
 * @author 3173
 * @description 新增/编辑
 * @Date  2020/9/28
 */
import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import LiveForm from './liveForm'
import moment from "moment";
import { formatAuth } from '@/utils/commonUtils';
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class LiveDetail extends WizContainer {
  componentName = 'liveDetail';

  constructor(props) {
    super(props);
    const { history } = this.props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增';
    if (history.location && history.location.pathname === '/live/liveList/liveUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('liveUpd', initialValue)
      } else {
        initialValue = Session.get('liveUpd') || {};
      }
      cardTitle = '编辑'
      if (initialValue.startDate) {
        initialValue.startDate = moment(initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (initialValue.endDate) {
        initialValue.endDate = moment(initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
    }
    this.state = {
      cardTitle: cardTitle,
      formKey: 'liveForm',
      formInitialValue:{},
      checkDateInfo : undefined
    }
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'interactLive/selectInteractLiveDetailInfo',
        payload: {
          key: "getLiveInfo",
          apiParams: {
            id: this.initialValue.id
          }
        }
      });
    }
  }

  /**校验对应时间段是否有直播资源 */
  checkMeetingDate(startDate, endDate,meetingNo,type,videoTool) {
    this.setState({
      checkDateInfo : undefined
    })
    this.doAction({
      path: 'interactLive/checkMeetingDate',
      payload: {
        key: 'interactLive@checkMeetingDate',
        apiParams: {
          startDate,
          endDate,
          meetingNo,
          type,
          videoTool
        }
      }
    });
  }

  propsAndStateOnChange = {
    saveLive: this._saveLiveOver.bind(this),
    liveInfo: this._getliveInfoOver.bind(this),
    checkMeetingDate: this._checkMeetingDateOver.bind(this)
  }


  _saveLiveOver(nextProps, nextState) {
    if (nextProps.saveLive.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/live/liveList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveLive.msg);
    }
    return true;
  }

  _getliveInfoOver(nextProps, nextState) {
    if (nextProps.liveInfo.code == 1) {
      this.initialValue = nextProps.liveInfo.data;
      //数据拼接
      if(this.initialValue.hostId && this.initialValue.hostName){
        this.initialValue.personInfo = [{key:'1',personId:this.initialValue.hostId, fullName:this.initialValue.hostName ,id:this.initialValue.hostId}]
      }
      if(this.initialValue.liveCategoryId && this.initialValue.categoryName){
        this.initialValue.categoryInfo = [{key:this.initialValue.liveCategoryId,title:this.initialValue.categoryName}]
      }
      if (this.initialValue.startDate) {
        this.initialValue.startDate = moment(this.initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (this.initialValue.endDate) {
        this.initialValue.endDate = moment(this.initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
      nextState.formInitialValue = Object.assign({},this.initialValue)
      nextState.formKey = 'liveForm' + new Date().getTime()
    }
    return true;
  }

  _checkMeetingDateOver(nextProps, nextState) {
    if (nextProps.checkMeetingDate.code == 1) {
      nextState.checkDateInfo = nextProps.checkMeetingDate.data
    } else {

    }
    return true;
  }

  /**
   * 获取属性
   * @param values
   * @param key
   * @returns {null|*}
   * @private
   */
  _getVideoToolProperty(values,key){
    let value = null;
    if ( key ===undefined || key===null || key.trim() ===''){
      return value
    }
    value = 0;
    if (values[key] && values[key] instanceof Array && values[key].length>0) {
      value = values[key][0];
    }
    return value;
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const { history } = this.props;
    let apiPath = "interactLive/addInteractLive";
    values['videoTool'] = 2
    if (this.initialValue.id) {
      apiPath = "interactLive/updateInteractLive";
      values['videoTool'] = this.initialValue.videoTool
    }
    let liveType = values['liveType'];
    if (liveType!=null && (liveType===4 || liveType===5 || liveType===6)){
      let videoTool = values['videoTool'];
      if (videoTool!=null && videoTool===2){
        values.isHostCamera = this._getVideoToolProperty(values,'isHostCamera');
        values.isHostMic = this._getVideoToolProperty(values,'isHostMic');
        values.isParticipantPlatform = this._getVideoToolProperty(values,'isParticipantPlatform');
        values.isAllowCamera = this._getVideoToolProperty(values,'isAllowCamera');
        values.isParticipantCamera = this._getVideoToolProperty(values,'isParticipantCamera');
        values.isAllowMic = this._getVideoToolProperty(values,'isAllowMic');
        values.isParticipantMic = this._getVideoToolProperty(values,'isParticipantMic');
        values.isHallMode = this._getVideoToolProperty(values,'isHallMode');
        values.isFollowHost = this._getVideoToolProperty(values,'isFollowHost');
        values.isModifyResume = this._getVideoToolProperty(values,'isModifyResume');
      }else {
        values.videoTool = 1;
      }
      if (values['isAllowCamera'] && values['isAllowCamera'] instanceof Array && values['isAllowCamera'].length>0) {
        values.isAllowCamera = values['isAllowCamera'][0];
      }
    }else{
      values['videoTool'] = null
    }
    if (values && values['img'] && values['img'].length) {
      values.img = values.img[0].fileId;
    } else {
      values.img = "";
    }
    if (values['startDate'] && values['startDate']._d.getTime()) {
      values.startDate = values['startDate'].format('YYYY-MM-DD HH:mm:ss');
    }
    if (values['endDate'] && values['endDate']._d.getTime()) {
      values.endDate = values['endDate'].format('YYYY-MM-DD HH:mm:ss');
    }
    if(values.liveCategoryId){
      values.liveCategoryId = values.liveCategoryId[0];
    }
    let authCmd = {}
    if (values['authCmd']) {
      let authInfo = values['authCmd']
      if (liveType!=null && liveType===4){
        authCmd['orgIds'] = []
        authCmd['positionIds'] = []
        authCmd['positionCategoryIds'] = []
        if (authInfo && authInfo instanceof Array){
          authCmd['personIds'] = [...authInfo];
        }else {
          authCmd['personIds'] = [authInfo];
        }
      }else if(liveType!=null && (liveType===5 || liveType===6)){
        if (authInfo && authInfo instanceof Array && authInfo.length>25){
          wizNotice.error('提交失败：总人数限制25人，请确认后重试');
          return;
        }
        authCmd['orgIds'] = []
        authCmd['positionIds'] = []
        authCmd['positionCategoryIds'] = []
        authCmd['personIds'] = [...authInfo]
      }else {
        // authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
        // authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
        // authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
        // authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))

        authCmd = formatAuth(authInfo)
      }
      // authCmd.isAll = authInfo.isAll
    }
    values['authCmd'] = authCmd;

    if(values.isMessage && values.templateInfoList && values.templateInfoList.length){
      let templateInfoListNew = [];
      values.templateInfoList.forEach(element => {
        let assignTimeNew = undefined
        let authCmdNew = {}
        if(typeof element.assignTime === 'string'){
          assignTimeNew = element.assignTime
        }else{
          assignTimeNew = element.assignTime.format('YYYY-MM-DD HH:mm:ss')
        }
        if(element.authCmd && Object.keys(element.authCmd).length){
          authCmdNew = formatAuth(element.authCmd)
        }else if(element.authInfo && Object.keys(element.authInfo).length){
          authCmdNew = formatAuth(element.authInfo)
        }

        let realContent = element.realContent
        if(element.sendState==0){
          realContent = element.templateContent
          if(realContent.indexOf("${name}")!=-1 && values.hostName ){
            realContent = realContent.replace(/\$\{name\}/g, values.hostName);
          }
          if(realContent.indexOf("${liveName}")!=-1 && values.name ){
            realContent = realContent.replace(/\$\{liveName\}/g, values.name);
          }
          if(realContent.indexOf("${startTime}")!=-1 && values.startDate){
            realContent = realContent.replace(/\$\{startTime\}/g, values.startDate);
          }
          if(realContent.indexOf("${endTime}")!=-1 && values.endDate){
            realContent = realContent.replace(/\$\{endTime\}/g, values.endDate);
          }
        }
       
        templateInfoListNew.push({...element,authCmd:authCmdNew,assignTime:assignTimeNew,appIds:[],content:element.templateContent,realContent:realContent})
      });
      values.templateInfoList = templateInfoListNew
    }
    if(!values.hostId){
      values.hostId=""
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: "saveLive",
        apiParams: {
          ...values,
          state:this.initialValue.state?this.initialValue.state:1,
          id: this.initialValue.id
        }
      }
    });
  }


  _render() {
    const { interactLiveLoading } = this.props;
    let { cardTitle, formInitialValue,checkDateInfo } = this.state;



    return <WizCard>
      <WizSpin tip={'加载中'} spinning={interactLiveLoading}>

        <LiveForm className={'form-inline'} key={this.state.formKey} initialValue={this.initialValue}
          onSubmit={this._save.bind(this)} checkMeetingDate={this.checkMeetingDate.bind(this)} checkDateInfo={checkDateInfo}/>

      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLive } = state;
  const saveLive = modelUtils.getModelEntity(interactLive, "saveLive");
  const liveInfo = modelUtils.getModelEntity(interactLive, "getLiveInfo");
  const checkMeetingDate = modelUtils.getModelEntity(interactLive, "interactLive@checkMeetingDate");
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    saveLive: saveLive,
    liveInfo,
    checkMeetingDate,
    ...load
  }
};

export default connect(mapStateToProps)(LiveDetail);
